import React from "react";
import SectionTitle from "../components/SectionTitle";
import InfoData from "../InfoData";
import SectionWrapper from "../components/SectionWrapper";
import Card from "../components/Card";
import animateCSS from "../assets/js/animatecss";
import { useInView } from "react-intersection-observer";

const education = InfoData.education;

const Education = () => {

    const EducationItem = ({itemInfo, isOdd}) => {
        const {ref} = useInView({
            onChange: setInView,
        });

        const period = itemInfo.period_start + ' - ' + itemInfo.period_end;
        return (
            <div ref={ref}>
                <Card classes={`p-8 mb-8 ${isOdd ? "border-primary" : "border-secondary"}`}>
                    <div className={`flex justify-between items-center flex-wrap-reverse text-xl font-bold ${isOdd ? 'text-primary' : 'text-secondary'}`}>
                        <div>{itemInfo.name}</div>
                        <div className="ml-auto">{period}</div>
                    </div>
                    <div>{itemInfo.description}</div>
                </Card>
            </div>
        );
    };
    
    const EducationContent = () => {
        return (
            <div className="mt-8">
                {
                    education.map((itemInfo, index) => (
                        <EducationItem 
                            key={index} 
                            itemInfo={itemInfo} 
                            isOdd={index % 2 === 0}
                        />
                    ))
                }
            </div>
        )
    }

    const setInView = (inView, entry) => {
        if (inView) {
            animateCSS(entry.target, 'backInRight');
            entry.target.classList.remove('invisible');
        } else {
            entry.target.classList.add('invisible');
        }
    }

    return (
        <SectionWrapper id="education">
            <SectionTitle title="Education"/>
            <EducationContent/>
        </SectionWrapper>
    );
}

export default Education;